export default "__VITE_ASSET__b932b562__"